import { render, staticRenderFns } from "./delete-data-popup.html?vue&type=template&id=6be307cc&scoped=true&external"
import script from "./delete-data-popup.js?vue&type=script&lang=js&external"
export * from "./delete-data-popup.js?vue&type=script&lang=js&external"
import style0 from "./delete-data-popup.scss?vue&type=style&index=0&id=6be307cc&prod&scoped=true&lang=scss&external"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6be307cc",
  null
  
)

export default component.exports